import { render, staticRenderFns } from "./CrewsCreateEdit.vue?vue&type=template&id=0684e806"
import script from "./CrewsCreateEdit.vue?vue&type=script&lang=js"
export * from "./CrewsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports